import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    lat: Number,
    lng: Number,
    address: String
  }

  connect() {
    if (!window.ymaps || this.map) return

    ymaps.ready(() => {
      if (this.map) return

      const center = [this.latValue, this.lngValue]
      this.map = new ymaps.Map(this.element, {
        center: center,
        zoom: 16,
        controls: ["zoomControl", "fullscreenControl"]
      }, {
        searchControlProvider: "yandex#search"
      })

      const placemark = new ymaps.Placemark(center, {
        balloonContentHeader: "Адрес заявки",
        balloonContentBody: this.addressValue
      })

      this.map.geoObjects.add(placemark)
    })
  }

  disconnect() {
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  }
}
